<template>
  <header id="header">
    <div class="container">
      <div class="logo">
        <router-link :to="{'name' : 'Home'}"><img src="/assets/images/logo.png" alt="Logo"></router-link>
      </div>
      <div class="primary-menu">
        <template v-if="jwt">
          <router-link :to="{ name: 'Dashboard' }" class="btn">{{$t('TEXT_DASHBOARD')}}</router-link>
        </template>
        <template v-else>
          <a href="javascript:;" @click="login" class="btn btn-primary">{{$t('TEXT_LOGIN')}}</a>
          <a href="javascript:;" @click="openRegister" class="btn btn-second">{{$t('TEXT_REGISTER')}}</a>
        </template>
      </div>
    </div>
  </header>
</template>
<script>
export default {
  computed: {
    configs () {
      return this.$store.getters.configs
    },
    jwt () {
      return this.$store.getters.jwt
    }
  },
  methods: {
    login () {
      this.$store.dispatch('toggleLoginFormModal')
    },
    openRegister () {
      if (!this.configs.isAllowRegister) {
        this.$store.dispatch('showErrorMsg', this.$t('TEXT_REGISTER_LOCKED'))
        return
      }
      this.$store.dispatch('toggleRegisterFormModal')
    }
  }
}
</script>
